import { NavLink, useSearchParams } from 'react-router-dom';

type StatusSidebarLinkProps = {
  to: string;
  label: string;
  isActive: boolean;
};

export const StatusSidebarLink = ({
  to,
  label,
  isActive,
}: StatusSidebarLinkProps) => {
  return (
    <NavLink
      to={to}
      className={() => {
        const classname =
          'group relative flex items-center gap-2.5 rounded-md px-4 text-sm duration-300 ease-in-out hover:text-white ' +
          (isActive ? 'font-bold text-primary' : 'font-light text-secondary');
        return classname;
      }}
    >
      {label}
    </NavLink>
  );
};
